'use strict';

import angular from 'angular';
import Controller from './controller';

function Factory($uibModal) {
    'ngInject';

    return function () {
        return $uibModal.open({
            template: require('./view.html'),
            controller: 'DeputyImportController',
            controllerAs: 'vm',
        }).result;
    }
}


export default angular.module('accessApp.DeputyImport', [])
    .controller('DeputyImportController', Controller)
    .factory('DeputyImportFactory', Factory)
    .name;


// WEBPACK FOOTER //
// ./client/app/modals/deputy-import/index.js